<template>
  <nav class="navbar">
    <div class="container">
      <router-link :title="isEnglish ? 'Home | Nyenyezia Forex' : 'Accueil | Nyenyezia Forex'" :to="localizedPath('/')" class="logo__anchor">
        <div class="logo">
          <img src="@/assets/logo.png" alt="Logo" class="logo__img" />
          <span class="logo__text gold">Nyenyezia Forex</span>
        </div>
      </router-link>

      <button class="burger" @click="toggleMenu">
        <span :class="{ open: isMenuOpen }"></span>
        <span :class="{ open: isMenuOpen }"></span>
        <span :class="{ open: isMenuOpen }"></span>
      </button>

      <ul class="nav-links" :class="{ active: isMenuOpen }">
        <li><router-link :title="isEnglish ? 'Exchange Rates | Nyenyezia Forex' : 'Taux change | Nyenyezia Forex'" :to="localizedPath('/taux-de-change')">{{ isEnglish ? 'Exchange Rates' : 'Taux de change' }}</router-link></li>
        <li><router-link title="Services | Nyenyezia Forex" :to="localizedPath('/services')">Services</router-link></li>
        <li><router-link :title="isEnglish ? 'About | Nyenyezia Forex' : 'À propos | Nyenyezia Forex'" :to="localizedPath('/a-propos')">{{ isEnglish ? 'About' : 'À propos' }}</router-link></li>
        <li><router-link title="FAQ | Nyenyezia Forex" :to="localizedPath('/faq')">FAQ</router-link></li>
        <li><router-link title="Contact | Nyenyezia Forex" :to="localizedPath('/contact')">Contact</router-link></li>
        <li><router-link :title="isEnglish ? 'Français | Nyenyezia Forex' : 'English | Nyenyezia Forex'" :to="languageTogglePath">{{ isEnglish ? 'FR' : 'EN' }}</router-link></li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "NavbarComponent",
  data() {
    return {
      isMenuOpen: false,
    };
  },
  computed: {
    isEnglish() {
      return this.$route.path.startsWith('/en');
    },
    languageTogglePath() {
      if (this.isEnglish) {
        return this.$route.path.replace(/^\/en/, '') || '/';
      }
      return this.$route.path === '/' ? '/en' : '/en' + this.$route.path;
    }
  },
  methods: {
    localizedPath(path) {
      if (!this.isEnglish) return path;
      return path === '/' ? '/en' : '/en' + path;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
  watch: {
    $route() {
      this.isMenuOpen = false;
    },
  },
};
</script>

<style scoped>
.navbar {
  background-color: #fff;
  color: #001041;
  padding: 15px 20px;
  border-bottom: 3px solid #c39446;
  position: fixed;
  width: 100%;
  z-index: 100;
  top: 0;
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.nav-links {
  list-style: none;
  display: flex;
  gap: 20px;
  transition: max-height 0.3s ease;
}

.nav-links a {
  color: #001041;
  text-decoration: none;
  font-weight: bold;
  padding: 10px 0;
  transition: all 0.3s ease;
}

.nav-links a:hover {
  border-bottom: 3px solid #c39446;
  color: #c39446;
}

.burger {
  display: none;
  flex-direction: column;
  gap: 5px;
  border: none;
  background: none;
  cursor: pointer;
}

.burger span {
  width: 25px;
  height: 3px;
  background-color: #001041;
  transition: all 0.3s ease;
}

.burger span.open:nth-child(1) {
  transform: rotate(45deg) translateY(8px);
}

.burger span.open:nth-child(2) {
  opacity: 0;
}

.burger span.open:nth-child(3) {
  transform: rotate(-45deg) translateY(-8px);
}

/* Responsive Styles */
@media (max-width: 768px) {
  .nav-links {
    flex-direction: column;
    max-height: 0;
    overflow: hidden;
  }

  .nav-links.active {
    max-height: 300px; /* Adjust based on the number of links */
  }

  .burger {
    display: flex;
  }
}
</style>

<style scoped>
.navbar {
  background-color: #fff;
  color: #001041;
  padding: 15px 20px;
  border-bottom: 3px solid #c39446;
  position: fixed;
  width: 100%;
  z-index: 100;
  top: 0;
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

/* Navigation Links (Desktop Default) */
.nav-links {
  list-style: none;
  display: flex;
  gap: 20px;
}

.nav-links a {
  color: #001041;
  text-decoration: none;
  font-weight: bold;
  padding: 10px 0;
  transition: all 0.3s ease;
}

.nav-links a:hover {
  border-bottom: 3px solid #c39446;
  color: #c39446;
}

/* Logo Styles */
.logo {
  text-decoration: none !important;
}

.logo__anchor {
  text-decoration: none;
}

.logo__img {
  height: 24px;
}

.logo__text {
  font-size: 32px;
  font-weight: bold;
}

.gold {
  color: #c39446;
}

/* Burger Menu Button */
.burger {
  display: none;
  flex-direction: column;
  gap: 5px;
  border: none;
  background: none;
  cursor: pointer;
}

.burger span {
  width: 25px;
  height: 3px;
  background-color: #001041;
  transition: all 0.3s ease;
}

.burger span.open:nth-child(1) {
  transform: rotate(45deg) translateY(8px);
}

.burger span.open:nth-child(2) {
  opacity: 0;
}

.burger span.open:nth-child(3) {
  transform: rotate(-45deg) translateY(-8px);
}
/* Mobile Styles */
@media (max-width: 930px) {
  .logo__text {
    font-size: 24px;
  }
}
/* Mobile Styles */
@media (max-width: 820px) {
  .nav-links {
    display: none;
    flex-direction: column;
    gap: 10px;
    background-color: #fff;
    position: absolute;
    top: 60px;
    right: 20px;
    padding: 10px 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }

  .nav-links.active {
    display: flex;
  }

  .burger {
    display: flex;
  }
  .logo__text {
    font-size: 16px;
  }
}
</style>
